import { Translate } from '@chipinside/translate'

import { PageLoader } from '#/contexts/Loader/loader'
import { Error403 } from '#/pages/Fallback/403'
import Error500 from '#/pages/Fallback/500'
import NotFound from '#/pages/Fallback/NotFound'
import TooManyAttempts from '#/pages/Fallback/TooManyAttempts'

function PageError({ code }) {
  if (code) {
    switch (code) {
      case 403:
        return <Error403 />

      case 404:
        return <NotFound />

      case 429:
        return <TooManyAttempts />

      case 500:
        return <Error500 />

      default:
        return (
          <PageLoader
            loading
            error
            title={Translate({ messageKey: 'response_error' })}
            subtitle={Translate({ messageKey: 'error_500' })}
          />
        )
    }
  }
}

export default PageError
